import styled, { css } from 'styled-components';

export const BookingButton = styled.div<{ disabled: boolean }>`
  background-color: var(--white);
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  padding: 0 20px;
  span {
    font-size: 12px;
    font-weight: 500;
  }
  span:last-child {
    font-size: 18px;
    font-weight: 600;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      border-radius: 15px;
      border: solid 1px var(--black);
      cursor: not-allowed;
    `}
`;

export const FormTimeContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;

  input[type='radio'] {
    position: absolute;
    opacity: 0;
    cursor: none;
    height: 0;
    width: 0;

    &:checked ~ ${BookingButton} {
      background-color: var(--black);
      span {
        color: var(--white);
      }
    }
  }
`;

export const FormTimeLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  margin: 0 auto;
  gap: 16px;
  padding: 0 20px;
  @media (max-width: 1200px) {
    padding: 0;
  }
`;

export const FormTimeLabel = styled.label`
  cursor: pointer;
  user-select: none;
`;
